import { createSelector } from '@reduxjs/toolkit'

const getSelfEmploymentSummary = (state) => state.selfEmploymentSummary
const getSelfEmploymentActivities = (state) => state.selfEmploymentActivities
export const getSelfEmploymentActivityItems = (state) => state.selfEmploymentActivities.items || []

export const getSelfEmploymentActivitiesTotalIncome = createSelector(
    [getSelfEmploymentActivityItems],
    (selfEmploymentActivities) => selfEmploymentActivities.reduce((total, { income = 0 }) => total + income, 0)
)

export default createSelector(
    [getSelfEmploymentSummary, getSelfEmploymentActivities],
    (selfEmploymentSummary, selfEmploymentActivities) => ({
        hasSelfEmploymentSummary: !!selfEmploymentSummary.taxReturnId,
        selfEmploymentSummary,
        selfEmploymentSummaryStatus: selfEmploymentSummary.status,
        selfEmploymentActivities,
    })
)
